import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../../services/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setMessage({
        type: "error",
        text: "Link de redefinição inválido. Por favor solicite um novo link.",
      });
      return;
    }

    if (password.length < 6) {
      setMessage({
        type: "error",
        text: "A senha deve ter pelo menos 6 caracteres.",
      });
      return;
    }

    if (password !== confirmPassword) {
      setMessage({
        type: "error",
        text: "As senhas não coincidem.",
      });
      return;
    }

    try {
      setLoading(true);
      setMessage({ type: "", text: "" });

      const res = await api.post("/auth/reset-password", {
        token,
        password,
      });

      setMessage({
        type: "success",
        text: res.data?.message || "Senha alterada com sucesso!",
      });

      setTimeout(() => {
        navigate("/login");
      }, 2500);
    } catch (err) {
      const errorMsg = err?.response?.data?.message;
      setMessage({
        type: "error",
        text: errorMsg || "Não foi possível redefinir sua senha. Tente novamente.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFC] flex flex-col justify-between p-4 sm:p-6 antialiased selection:bg-[#ECE7FA]">
      <div className="flex-1 flex items-center justify-center py-8">
        <div className="w-full max-w-md bg-white rounded-[28px] p-6 sm:p-8 shadow-2xl border border-[#ECE7FA] space-y-6">
          <div className="text-center space-y-2">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#6C54D8] text-white font-black text-2xl shadow-md">
              m
            </div>
            <h1 className="text-2xl font-bold text-[#24152F] font-serif pt-2">
              Criar Nova Senha
            </h1>
            <p className="text-xs text-[#6D6680] font-medium">
              Digite e confirme a sua nova senha de acesso ao MariaM.
            </p>
          </div>

          {message.text && (
            <div
              className={`rounded-2xl p-4 text-xs font-bold text-center ${
                message.type === "success"
                  ? "bg-[#CBF1DB]/60 border border-[#CBF1DB] text-emerald-900"
                  : "bg-red-50 border border-red-200 text-red-800"
              }`}
            >
              {message.text}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-[#6D6680] mb-1">
                Nova Senha
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="No mínimo 6 caracteres"
                required
                className="input-base w-full h-11 text-xs font-medium"
              />
            </div>

            <div>
              <label className="block text-xs font-bold uppercase tracking-wider text-[#6D6680] mb-1">
                Confirmar Nova Senha
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Repita a nova senha"
                required
                className="input-base w-full h-11 text-xs font-medium"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full h-12 text-xs font-bold uppercase tracking-wider shadow-md flex items-center justify-center gap-2 cursor-pointer mt-2"
            >
              {loading ? "Redefinindo..." : "Salvar Nova Senha"}
            </button>
          </form>

          <div className="text-center pt-2">
            <Link
              to="/login"
              className="text-xs font-bold text-[#6C54D8] hover:underline"
            >
              ← Voltar ao Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
